<aside
  class="fixed inset-x-0 bottom-0 top-[72px] z-[100] flex flex-col bg-[#040B78] text-white"
  aria-label="Mobile navigation"
>
  <section
    class="shrink-0 border-b border-[#1E63F0] bg-[#00086A] px-6 py-6 text-white"
  >
    <div class="text-base font-bold">{{ accountName() }}</div>
    <p class="mt-1 max-w-[520px] text-sm text-white/95">
      {{ billingAddress() }}
    </p>
  </section>

  @if (!stackDepth) {
    <div class="flex-1 overflow-y-auto bg-[#040B78]">
      <ul class="m-0 list-none p-0">
        @for (item of currentItems; track item.label) {
          <li
            [appNavigationRecord]="item"
            [isMobile]="true"
            (mobileNavigate)="itemNavigate.emit($event)"
            (mobileLinkNavigate)="itemLinkNavigate.emit()"
            (navigationRecordAction)="itemAction.emit($event)"
          ></li>
        }
      </ul>
    </div>
  } @else {
    <div class="flex min-h-0 flex-1">
      <div class="w-[72px] shrink-0">
        <ul class="m-0 list-none p-0">
          @for (item of rootItems; track item.label) {
            <li class="-mr-[1px]">
              <button
                type="button"
                class="relative flex w-full items-center justify-center pl-2"
                (click)="rootSelect.emit(item)"
                [attr.aria-label]="item.ariaLabel || item.label"
              >
                <span
                  class="flex w-full items-center justify-center rounded-l-lg rounded-r-none border-none p-4 transition-colors"
                  [ngClass]="{
                    'bg-[#1E63F0]': isActiveRoot(item),
                    'bg-transparent': !isActiveRoot(item),
                  }"
                >
                  @if (item.prefixIcon) {
                    @if (item.isSvg || item.prefixIcon === 'user-cb') {
                      @let iconPath =
                        'assets/images/icons/' + item.prefixIcon + '.svg';
                      <img
                        [alt]="item.label + ' icon'"
                        [src]="iconPath"
                        class="block h-7 w-7 shrink-0 object-contain font-thin"
                      />
                    } @else {
                      <mat-icon class="!text-[28px] font-thin !text-white">
                        {{ item.prefixIcon }}
                      </mat-icon>
                    }
                  }
                </span>
              </button>
            </li>
          }
        </ul>
      </div>

      <div class="min-h-0 flex-1 bg-[#1E63F0]">
        <section class="px-4 pb-4 pt-6 text-white">
          <div class="flex items-start justify-between">
            <div class="px-2 text-sm font-bold uppercase tracking-[1.2px]">
              {{ currentTitle }}
            </div>

            <button
              type="button"
              class="flex h-6 w-6 items-center justify-center"
              (click)="backNav.emit()"
              aria-label="Back"
            >
              <mat-icon class="!text-[24px] !text-white">close</mat-icon>
            </button>
          </div>

          <div class="mt-5 h-px bg-white/80"></div>
        </section>

        <div class="min-h-0 flex-1 overflow-y-auto">
          <ul class="m-0 list-none p-0">
            @for (item of currentItems; track item.label) {
              <li
                [appNavigationRecord]="item"
                [isMobile]="true"
                (mobileNavigate)="itemNavigate.emit($event)"
                (mobileLinkNavigate)="itemLinkNavigate.emit()"
                (navigationRecordAction)="itemAction.emit($event)"
              ></li>
            }
          </ul>
        </div>
      </div>
    </div>
  }
</aside>
